import { useSelector } from 'react-redux';
import { IApplicationState } from '../../../state';

interface IBusinessStandardPriceUpdate {
  isBusinessStandardPriceUpdateEnabled: boolean;
}

const useBusinessStandardPriceUpdate = (): IBusinessStandardPriceUpdate => {
  const isBusinessStandardPriceUpdateEnabled = useSelector((state: IApplicationState) => state.flags.BusinessStandardPriceUpdateEnabled);
  return {
    isBusinessStandardPriceUpdateEnabled
  };
};

export default useBusinessStandardPriceUpdate;
